import { Component, EventEmitter, input, Output } from '@angular/core';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-status-rollup',
    templateUrl: './status-rollup.component.html',
    styleUrls: ['./status-rollup.component.scss'],
    standalone: false
})
export class StatusRollupComponent {
  faCircleInfo = faCircleInfo;

  user = input.required<any>();
  type = input.required<any>();
  initTab = input.required<boolean>();
  summaryInfoSelected = input.required<any>();
  public = input.required<boolean>();
  @Output() changeIndexInit = new EventEmitter();
  today = new Date();

  tabChange() {
    this.changeIndexInit.emit('true');
  }
}
